// TeenPatti2 — 2 Cards Teenpatti (casino/patti2), reference shell: .casino-table.teenpatti2cards
import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router";
import BetTableTeenPatti2 from "../../casinoComponents/betTableTeenPatti2";
import VideoBox from "../../casinoComponents/videoBox";
import Patti2CardsOverlay from "../../casinoComponents/videoBox/overlays/Patti2CardsOverlay";
import Patti2VideoTitle from "../../casinoComponents/videoBox/overlays/Patti2VideoTitle";
import CasinoLastResult from "../../casinoComponents/casinoLastResult";
import CasinoTableLayout from "../../casinoComponents/casinoTableLayout";
import ViewMoreModal from "../../../components/ViewMoreModal";
import Patti2RightSide from "./Patti2RightSide";
import ResultPatti2 from "../resultui/resultPatti2/ResultPatti2";
import { getCasinoGameDetails, getMatchExposure, getCasinoOpenBets } from "../../../apiservices/CasionApi";
import { extractCasinoGame } from "../../../utils/casinoGame";
import { formatPatti2Nation, formatBetOdds } from "../../../utils/casinoMyBets";
import "../../../styles/games/patti2.css";

export default function TeenPatti2() {
  const [gameData, setGameData] = useState(null);
  const [exposures, setExposures] = useState({});
  const [myBets, setMyBets] = useState([]);
  const [showViewMoreModal, setShowViewMoreModal] = useState(false);
  // Reference title = last results' res1.cname ("2 Cards Teenpatti")
  const [gameTitle, setGameTitle] = useState("2 Cards Teenpatti");

  const { pathname } = useLocation();
  const gameName = extractCasinoGame(pathname) || "patti2";
  const iframeSrc = `https://stream-s-43.uhdmovies.online/casino-stream?id=${gameName}`;

  useEffect(() => {
    const fetchGameData = async () => {
      try {
        const response = await getCasinoGameDetails("patti2");
        setGameData(response);
      } catch (err) {
        console.error(err);
        setGameData(null);
      }
    };

    fetchGameData();
    const gameDataInterval = setInterval(fetchGameData, 1500);
    return () => clearInterval(gameDataInterval);
  }, [pathname, gameName]);

  const d = gameData?.data?.data;
  const mid = d?.mid ?? gameData?.data?.mid ?? gameData?.mid;

  const fetchExposure = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const userId = user?.user_id || user?.id || user?.staff_id || user?.owner_id;
      const matchId = mid?.toString();
      if (userId && matchId) {
        const response = await getMatchExposure(userId, matchId);
        if (response.success && response.data) {
          const exposureMap = {};
          response.data.forEach((item) => {
            const teamName = item.team_name || item.selection || item.player_name || "";
            const exposureAmount = parseFloat(item.exposure_amount) || 0;
            if (teamName) {
              exposureMap[teamName] = exposureAmount;
              exposureMap[teamName.trim()] = exposureAmount;
              exposureMap[teamName.toLowerCase().trim()] = exposureAmount;
              // Total A/B rows carry their line ("Total A 15"); the cell reads the side,
              // so it shows the sum of that side's line rows (share-weighted like the rest).
              const total = teamName.trim().match(/^(Total [AB]) \d+$/i);
              if (total) exposureMap[total[1]] = (exposureMap[total[1]] || 0) + exposureAmount;
            }
          });
          setExposures(exposureMap);
        }
      }
    } catch (error) {
      console.error("Error fetching exposure:", error);
    }
  }, [mid]);

  const fetchMyBetsData = useCallback(async () => {
    if (!gameName) return;
    try {
      const response = await getCasinoOpenBets(gameName);
      if (response?.success && Array.isArray(response.data)) {
        setMyBets(
          response.data.map((bet) => ({
            // My Bets "Gametype" column (casino_bets.game_name)
            description: bet.description ?? bet.game_name ?? bet.gameName,
            userName: bet.username ?? bet.userName ?? "-",
            matchedBet: bet.matchedBet ?? bet.nation ?? bet.selection ?? bet.player_name ?? "-",
            selection: bet.selection ?? bet.player_name ?? bet.matchedBet ?? "",
            player_name: bet.player_name ?? "",
            odds: bet.odds ?? bet.userrate ?? "0",
            stake: bet.stake ?? bet.amount ?? "0",
            placeDate: bet.placeDate ?? bet.created_at ?? "-",
            gametype: bet.gametype ?? bet.game_type ?? (bet.type === "lay" ? "Lay" : bet.type === "back" ? "Back" : "-"),
            type: bet.type ?? null,
            exposer: parseFloat(bet.exposer ?? bet.exposure_amount ?? "0") || 0,
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching my bets (open-downline):", error);
    }
  }, [gameName]);

  useEffect(() => {
    if (mid) {
      const first = setTimeout(fetchExposure, 0);
      const exposureInterval = setInterval(fetchExposure, 2000);
      return () => {
        clearTimeout(first);
        clearInterval(exposureInterval);
      };
    }
  }, [mid, fetchExposure]);

  useEffect(() => {
    const first = setTimeout(fetchMyBetsData, 0);
    const intervalId = setInterval(fetchMyBetsData, 3000);
    return () => {
      clearTimeout(first);
      clearInterval(intervalId);
    };
  }, [fetchMyBetsData]);

  // Admin view: no bet slip (reference admin has none) — an odds click just refreshes book / bets.
  const handleBetClick = () => {
    fetchExposure();
    fetchMyBetsData();
  };

  const remark = d?.remark ?? "";

  // Reference markup: .casino-table.teenpatti2cards has no .game-header — the title and round id
  // sit in the video (.casino-video-title, VideoBox titleNode).
  return (
    <CasinoTableLayout
      tableClass="teenpatti2cards"
      rightSide={<Patti2RightSide bets={myBets} onViewMore={() => setShowViewMoreModal(true)} />}
    >
      <VideoBox
        iframeSrc={iframeSrc}
        timerValue={d?.lt}
        gameType="patti2"
        titleNode={<Patti2VideoTitle title={gameTitle} roundId={mid} />}
        cardsOverlay={<Patti2CardsOverlay card={d?.card} />}
      />
      {mid ? (
        <div className="casino-detail">
          <BetTableTeenPatti2
            data={d?.sub || []}
            onBetClick={handleBetClick}
            exposures={exposures}
            myBets={myBets}
          />{" "}
          {remark !== "" && (
            <div className="casino-remark mt-3">
              <div className="remark-icon">
                <img src={`${import.meta.env.BASE_URL}assets/img/icons/remark.png`} alt="" />
              </div>{" "}
              <marquee>{remark}</marquee>
            </div>
          )}{" "}
          <CasinoLastResult
            gameType="patti2"
            resultComponent={<ResultPatti2 roundId={mid} onTitle={setGameTitle} />}
          />
        </div>
      ) : null}
      <ViewMoreModal
        show={showViewMoreModal}
        onHide={() => setShowViewMoreModal(false)}
        title="View More"
        sectionKey={gameName}
        formatNation={formatPatti2Nation}
        formatRate={(b) => formatBetOdds("patti2", b, b.odds ?? b.userrate)}
      />
    </CasinoTableLayout>
  );
}
